// ----------------------------
// Created by Bulletproof Games
//            2021
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Game Controller
//
// The game controller tracks and looks after the current game state, and orchestrates components
// ----------------------------

gameController = {};
gameController.isPrePaid = false;
gameController.inFreeSpins = false;
gameController.cyclingWins = false;
gameController.spinComplete = false;
gameController.bonusSymbolsLanded = 0;
gameController.fireballsLanded = 0;
gameController.minBonusForFeature = 3; //should be data driven
gameController.minBonusForFeature2 = 8; //should be data driven
gameController.minBonusForFeature2Anticipation = 5; //should be data driven
gameController.slamStopped = false;
gameController.playSingleBonus = true;
gameController.preFSReelPrize = 0;
gameController.wildSymbolsToStandOut = [];
gameController.startNextSpin = false;
gameController.cachedStart = false;
gameController.winSkipped = false;
gameController.spinHasWin = false;
gameController.animWinsFinished = true;
gameController.stoppingAutoplay = false;
gameController.gameRecovering = false;
gameController.lightningStriking = false;
gameController.stormLinkPayout = false;

gameController.wildTimers = [];

gameController.loseStreak = 0;

gameController.reelsAlreadyLanded = [];

gameController.retriggerTask = undefined;
gameController.doBigWinShake = false;

gameController.idleMusicTimer = undefined;

gameController.inBuyABonus = false;
gameController.isInFeature = false;
gameController.buyABonusHigh = false;
gameController.stormLinkSkip = true;

gameController.platformPopupActive = false;

// these are used to play a special sound on the eigth fireball landing
gameController.eigthFireballLanded = false;
gameController.allReelFireballCount = 0;

gameController.bonusLandSndIndex = 0;

gameController.justHadFreeSpins = false;
gameController.justHadFbl = false;

// for multiple reel spin sounds

gameController.inFirelink = false;
this.soundNum = 1;
gameController.isWildFire = false;

gameController.freespinsWinnings = 0;
gameController.stormlinkWinnings = 0;
gameController.jackpotBonusWinnings = 0;
gameController.potBonusWinnings = 0;
gameController.currentBlazingMultiplier = 1;
//gameController.currentPersistenceState = undefined;
gameController.reelStopping = [false, false, false, false, false, false];
gameController.volcanoAnimLocked = false;
gameController.currentVolcanoLevel = 0;

gameController.initialise = function () {
  gameController.bigWin = resourceManager.get("bigWin");

  gameController.baseReelFrame = resourceManager.get("slotContainer:reelFrame");

  gameController.thermometer = resourceManager.createObject(
    "spine",
    `thermometer`,
    `blazingMultiplier:thermometerContainer`,
    {
      name: "Thermometer",
      x: 145.5,
      y: 54.5,
      defaultAnimation: "Reset 1_5",
      anchor: 0.5,
      scaleX: 0.16,
      scaleY: 0.16,
      skin: "default",
    }
  );
  //poolSpine.setSkin("Normal");
  gameController.thermometer.play("Reset 1_5", true, 0, undefined);

  gameController.gatewayThermometer = resourceManager.createObject(
    "spine",
    `thermometer`,
    `slotContainer:fireballIntroPopup:fireballIntro:fireLinkEntryGateway:blazingMultiplierForIntro:blazingMultiplier:thermometerContainer`,
    {
      name: "Thermometer",
      x: 145.5,
      y: 54.5,
      defaultAnimation: "Reset 1_5",
      anchor: 0.5,
      scaleX: 0.16,
      scaleY: 0.16,
      skin: "default",
    }
  );

  gameController.padlock = resourceManager.createObject(
    "spine",
    `Padlock`,
    `blazingMultiplier:padlockContainer`,
    {
      name: "Padlock",
      x: 145,
      y: 53.5,
      defaultAnimation: "Padlock_Relock",
      anchor: 0.5,
      scaleX: 0.16,
      scaleY: 0.16,
      skin: "default",
    }
  );
  gameController.blazingMultiplierValue = resourceManager.get(
    "blazingMultiplier:value"
  );
  gameController.blazingMultiplierContainer =
    resourceManager.get("blazingMultiplier");
  gameController.blazingMultiplierFlame = resourceManager.get(
    "blazingMultiplier:flame"
  );

  gameController.volcanoParticle = particleManager.createEmitter(
    "volcano_ParticleEmitter",
    "VolcanoContainer",
    -20,
    -228,
    false
  );
  gameController.volcanoParticle.particleEmitter.emit = false;
  gameController.volcanoParticle.scale = { x: 2, y: 2 };

  gameController.volcano = resourceManager.createObject(
    "spine",
    `Volcano`,
    `VolcanoContainer`,
    {
      name: "Volcano",
      x: 0,
      y: 0,
      defaultAnimation: "Volcano_Intensity_1",
      anchor: 0.5,
      scaleX: 0.5,
      scaleY: 0.5,
      skin: "Day",
    }
  );
  gameController.volcano.setSkin("Day");
  gameController.volcano.play("Volcano_Intensity_1", true, 0, undefined);

  //Volcano Mixsetup

  gameController.volcano.spineObject.stateData.defaultMix = 0.1;

  gameController.volcanoSmoke = resourceManager.get(
    "VolcanoContainer:smokeMovie"
  );
  gameController.volcanoSmoke.visible = false;

  gameController.volcanoExplosion = resourceManager.get(
    "VolcanoContainer:explosionMovie"
  );
  gameController.padlock.play("Padlock_Relock", false, 0, undefined);

  gameController.slotMachine = resourceManager.getController("SlotMachine");
  const reelNames = ["reel0", "reel1", "reel2", "reel3", "reel4", "reel5"];
  gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    if (gameController.reelsAlreadyLanded.indexOf(reel) === -1) {
      gameController.onSpinLand(reel);
    }
    gameController.reelsAlreadyLanded.push(reel);
  });
  gameController.slotMachine.subscribeToReelsHitEvent(function (reelId) {
    const reel = reelNames.indexOf(reelId);
    gameController.playLandSounds(reel);
    gameController.onSpinHit(reel);
  });
  for (let i = 0; i < gameData.numReels; ++i) {
    let rv = resourceManager.get("slotContainer:reelContainer:reel" + i);

    rv.reassignSlotMachine(gameController.slotMachine);
  }

  gameController.redrawSymbols(gameController.slotMachine);

  gameController.slotMachine.selectReelMode("default");

  gameController.winlineAnimator = resourceManager.getSharedPlugin(
    "GameWinlineCatMullRomAnimatorEx"
  );

  gameController.firelink = resourceManager.get(
    "slotContainer:firelinkFeatureContainer:firelinkFeature"
  );

  gameController.jackpot = resourceManager.get(
    "slotContainer:jackpotBonusFeatureContainer:jackpotBonusFeature"
  );

  gameController.originalStopDistances =
    gameController.slotMachine._currentMode.stopDistances;

  gameController.winningsContainer = resourceManager.get("meterContainer");
  gameController.winningsContainer.visible = false;

  gameController.longSpinParticles = [
    {
      left: resourceManager.get("slotContainer:reelEffects:reel0Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel1Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel1Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel2Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel2Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel3Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel3Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel4Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel4Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel5Effect"),
    },
    {
      left: resourceManager.get("slotContainer:reelEffects:reel5Effect"),
      right: resourceManager.get("slotContainer:reelEffects:reel6Effect"),
    },
  ];
  gameController.stopAnticipation();

  gameController.redLightningAnticipations = [];

  gameController.colorMatrix = new PIXI.filters.ColorMatrixFilter();
  gameController.colorMatrix.hue(145, false);

  gameController.winControllerMain =
    resourceManager.getController("WinControllerMain");

  gameController.scatterSymbolReels = [];
  gameController.reelFireballs = [];
  for (let i = 0; i < gameData.numReels; ++i) {
    let rowFireballs = [];
    for (let row = 0; row < gameData.numRows; ++row) {
      const fireball = resourceManager.get(
        "slotContainer:reelFireballs:fireball_" + i + "_" + row
      );
      rowFireballs.push(fireball);
    }
    gameController.reelFireballs.push(rowFireballs);
  }

  gameController.symbolAnimator = resourceManager.get(
    "slotContainer:SymbolAnimator"
  );
  gameController.symbolLandAnimator = resourceManager.get(
    "slotContainer:BonusLandAnimator"
  );
  gameController.wildLandAnimator = resourceManager.get(
    "slotContainer:WildLandAnimator"
  );

  gameController._fblLogo = resourceManager.get("slotContainer:stormLinkLogo");
  gameController._fblLogo.visible = false;

  resourceManager.get("fireballLinkIntroDim").visible = false;
  gameController.wildFire = resourceManager.get(
    "slotContainer:reelEffects:wildFireContainer:wildFireAnim"
  );

  gameController.onOrientationChange();

  gameController.shaker = resourceManager.get("slotShaker");
  gameController.nightBackground = resourceManager.get(
    "baseGameBackground:landscapeBackground:nightBackground"
  );
  gameController.nightBackgroundPortrait = resourceManager.get(
    "baseGameBackground:portraitBackground:nightBackground"
  );

  gameController.chevronMovie = resourceManager.get(
    "slotContainer:reelContainer:chevron"
  );
  gameController.extraHotSymbol = resourceManager.get(
    "slotContainer:reelContainer:blazingBountyExtraHot"
  );
  gameController.extraHotSymbolStartingPos = resourceManager.get(
    "slotContainer:reelContainer:blazingBountyExtraHotStartingPos"
  );

  gameController.extraHotSymbol.visible = false;

  gameController.fireParticle = particleManager.createEmitter(
    "fire_ParticleEmitter",
    "slotContainer:reelContainer:particleContainer",
    0,
    0,
    false
  );
  gameController.fireParticle.particleEmitter.emit = false;

  gameController.popoutInitialWilds();

  let animationName = "x" + gameController.currentBlazingMultiplier;
  animationName = animationName.replace(".", "_");
  gameController.thermometer.play(animationName, true, 0, undefined);

  gameController.reelMaskContainer = resourceManager.get(
    "slotContainer:reelContainer:reelMaskContainer"
  );

  gameController.SixOfAKindContainer = resourceManager.get(
    "slotContainer:6OfAKindWinContainer"
  );
  gameController.SixOfAKindText = resourceManager.get(
    "slotContainer:6OfAKindWinContainer:6OfAKindText"
  );

  gameController.SixOfAKindRay = resourceManager.get(
    "slotContainer:6OfAKindWinContainer:rays"
  );

  const mask1 = new PIXI.Graphics();
  mask1.beginFill(0xff0000);
  //0xff0000
  mask1.drawRect(0, 0, 1, 1);
  mask1.endFill();
  mask1.scale.x = 895;
  mask1.scale.y = 462;

  gameController.reelMaskContainer.addChild(mask1);
  gameController.SixOfAKindText.mask = mask1;
  gameController.SixOfAKindRay.mask = mask1;
  gameController.screenDim = resourceManager.get(
    "slotContainer:jackpotBonusFeatureContainer:dimReels"
  );
  gameController.jackpotBoostTimer = undefined;
};

gameController.redrawSymbols = function (sm) {
  let reelVisuals = sm._reelVisuals;
  for (let i = 0; i < reelVisuals.length; ++i) {
    reelVisuals[i].redraw();
  }
};

gameController.popoutInitialWilds = function () {
  const symbols = resourceManager.getConfiguration().symbols;
  let symbolsToAnimate = [];
  for (
    let reel = 0;
    reel < gameData.slotConfig.startingSymbols.length;
    ++reel
  ) {
    for (
      let row = 0;
      row < gameData.slotConfig.startingSymbols[reel].symbols.length;
      ++row
    ) {
      const symbolId =
        gameData.slotConfig.startingSymbols[reel].symbols[row].value;
      if (symbolId === symbols["Symbol_SWild"].ID) {
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_SWild"].ID,
        };
        gameController.wildSymbolsToStandOut.push(symbolData);
        symbolsToAnimate.push(symbolData);
      } else if (symbolId === symbols["Symbol_SWild_x2"].ID) {
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_SWild_x2"].ID,
        };
        gameController.wildSymbolsToStandOut.push(symbolData);
        symbolsToAnimate.push(symbolData);
      } else if (symbolId === symbols["Symbol_SWild_x3"].ID) {
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_SWild_x3"].ID,
        };
        gameController.wildSymbolsToStandOut.push(symbolData);
        symbolsToAnimate.push(symbolData);
      }
    }
  }

  if (symbolsToAnimate.length > 0) {
    gameController.wildLandAnimator.animateSymbols(
      symbolsToAnimate,
      gameController.slotMachine,
      false,
      false,
      function () {}
    );
  }
};

gameController.playLandSounds = function (reel) {
  let fireballsOnThisReel = gameController.countFireballsOnReel(reel);

  // keep a running total of fireballs landed as the 8th one needs a different sound
  gameController.allReelFireballCount += fireballsOnThisReel;

  soundManager.play("reelStop" + reel);
  const rand = Math.floor(Math.random() * (2 - 0 + 1)) + 0;
  // play sound if fireball on reel - special case for eigth fireball
  if (fireballsOnThisReel > 0) {
    if (
      gameController.allReelFireballCount >=
        gameController.minBonusForFeature2 &&
      !gameController.eigthFireballLanded
    ) {
      soundManager.play(`eigthBallLand`);
      gameController.eigthFireballLanded = true;
    } else {
      soundManager.play(`fireBallLand${rand}`);
    }
  }
};

gameController.start = function () {
  gameController.stateMachine.switchState("WAITING_FOR_START");
};

gameController.shuffle = function (array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

gameController.onSpinComplete = function () {
  console.log("🔵 Spin Complete");

  gameController.spinComplete = true;
  soundManager.stop("reelSpin");
  gameController.reelStopping = [false, false, false, false, false, false];
  gameController.setState_WaitingForServer(gameController.spinTask);
  //}
};

gameController.animateFSSpinSymbolLand = function (reel) {};

gameController.animateFSSpinSymbolWin = function (reel, callback) {};

gameController.isBonusThisSpin = function () {
  let bonusCount = 0;
  for (let i = 0; i < gameData.numReels; i++) {
    bonusCount += gameController.countBonusOnReel(i);
  }
  return bonusCount >= gameController.minBonusForFeature;
};

gameController.countSymbolOnReel = function (reel, symbolString) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultsPanel.reelList[reel].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }

  const symbols = resourceManager.getConfiguration().symbols;
  const found = reelSymbols.find(function (symbol) {
    return symbol.value === symbols[symbolString].ID;
  });

  if (found !== undefined) {
    return 1;
  } else {
    return 0;
  }
};

gameController.countBonusOnReel = function (reel) {
  return gameController.countSymbolOnReel(reel, "Symbol_Bonus");
};

gameController.countRetriggerBonusOnReel = function (reel) {
  return gameController.countSymbolOnReel(reel, "Symbol_Bonus_Retrigger");
};

gameController.countFireballsOnReel = function (reel) {
  let reelSymbols = [];
  if (gameController.spinTask.data.resultsPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultsPanel.reelList[reel].symbols;
  }
  if (gameController.spinTask.data.resultPanel !== undefined) {
    reelSymbols =
      gameController.spinTask.data.resultPanel.reelList[reel].symbols;
  }
  let numFireballs = 0;

  reelSymbols.forEach(function (row) {
    if (gameController.symbolIsFireball(row.value)) {
      ++numFireballs;
    }
  });

  return numFireballs;
};

gameController.onSpinLand = function (reel) {
  console.log("🔵 On Spin Land");
  gameData.reels[reel].clearDimSymbolIds(0.3);

  gameData.reelsSpinning--;

  if (!gameController.inFreeSpins) {
    if (gameData.reelsSpinning === 0) {
      soundManager.stop("reelSpin");
      gameController.wildFire.hideAll();

      gameController.stopAnticipation();

      if (
        gameController.bonusSymbolsLanded < gameController.minBonusForFeature
      ) {
        gameController.symbolLandAnimator.skip();
      }
    }
  }

  const symbols = resourceManager.getConfiguration().symbols;
  let wildsToAnimate = [];
  let row = 0;
  for (
    ;
    row <
    gameController.spinTask.data.resultPanel.reelList[reel].symbols.length;
    ++row
  ) {
    if (
      gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
        .value === symbols["Symbol_SWild"].ID
    ) {
      let symbolData = {
        cell: { reel: reel, row: row },
        symbolId: symbols["Symbol_SWild"].ID,
      };
      gameController.wildSymbolsToStandOut.push(symbolData);
      wildsToAnimate.push(symbolData);
    } else if (
      gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
        .value === symbols["Symbol_SWild_x2"].ID
    ) {
      let symbolData = {
        cell: { reel: reel, row: row },
        symbolId: symbols["Symbol_SWild_x2"].ID,
      };
      gameController.wildSymbolsToStandOut.push(symbolData);
      wildsToAnimate.push(symbolData);
      break;
    } else if (
      gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
        .value === symbols["Symbol_SWild_x3"].ID
    ) {
      let symbolData = {
        cell: { reel: reel, row: row },
        symbolId: symbols["Symbol_SWild_x3"].ID,
      };
      gameController.wildSymbolsToStandOut.push(symbolData);

      wildsToAnimate.push(symbolData);
      break;
    }
  }
  if (wildsToAnimate.length > 0) {
    gameController.wildLandAnimator.animateSymbols(
      wildsToAnimate,
      gameController.slotMachine,
      false,
      false,
      function () {}
    );
  }
};

gameController.onSpinHit = function (reel) {
  console.log(`🔵 Spin Hit ${reel}`);
  const onReel = false; //gameController.countBonusOnReel(reel);
  gameController.reelStopping[reel] = true;
  gameController.bonusSymbolsLanded += onReel;

  const reelsNotLanded = gameData.numReels - reel;

  if (gameController.inFreeSpins) {
    const retrigger = gameController.countRetriggerBonusOnReel(reel);

    if (retrigger) {
      soundManager.play("freeSpinsBonusLand");
    }
  } else {
    if (onReel) {
      if (
        gameController.bonusSymbolsLanded + reelsNotLanded >
        gameController.minBonusForFeature
      ) {
        const symbols = resourceManager.getConfiguration().symbols;
        let row = 0;
        for (
          ;
          row <
          gameController.spinTask.data.resultPanel.reelList[reel].symbols
            .length;
          ++row
        ) {
          if (
            gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
              .value === symbols["Symbol_Bonus"].ID
          ) {
            break;
          }
          if (
            gameController.spinTask.data.resultPanel.reelList[reel].symbols[row]
              .value === symbols["Symbol_FireballExtraHot"].ID
          )
            soundManager.play("extraHotLand");
        }
        let symbolData = {
          cell: { reel: reel, row: row },
          symbolId: symbols["Symbol_Bonus"].ID,
        };

        if (gameController.slamStopped) {
          if (gameController.playSingleBonus) {
            soundManager.play("bonusLand0");
            gameController.playSingleBonus = false;
          }
        } else {
          soundManager.play("bonusLand" + gameController.bonusLandSndIndex);
          gameController.bonusLandSndIndex++;
        }

        gameController.symbolLandAnimator.animateSymbols(
          [symbolData],
          gameController.slotMachine,
          true,
          true,
          function () {}
        );
      }
    }
  }

  const fireballsOnReel = gameController.countFireballsOnReel(
    reel,
    "Symbol_Bonus"
  );
  gameController.fireballsLanded += fireballsOnReel;

  const scatterBonusAnticipation =
    gameController.bonusSymbolsLanded >=
      gameController.minBonusForFeature - 1 &&
    gameController.bonusSymbolsLanded + reelsNotLanded >=
      gameController.minBonusForFeature;
  const scatterBonusIsPossible =
    gameController.fireballsLanded >=
      gameController.minBonusForFeature2Anticipation &&
    gameController.fireballsLanded + reelsNotLanded * gameData.numRows >=
      gameController.minBonusForFeature2;

  if (
    reel < gameData.numReels - 1 &&
    (scatterBonusAnticipation || scatterBonusIsPossible)
  ) {
    gameController.stopAnticipation();

    let reelIndex = reel;
    gameData.musicManager.fadeOutAllMusic();
    soundManager.play(`anticipation${reelIndex + 1}`);

    gameController.longSpinParticles[reel + 1].left.gotoAndPlay(0);
    gameController.longSpinParticles[reel + 1].left.visible = true;
    gameController.longSpinParticles[reel + 1].right.gotoAndPlay(0);
    gameController.longSpinParticles[reel + 1].right.visible = true;
  } else {
    gameController.stopAnticipation();
  }
};

gameController.stopAnticipation = function () {
  console.log("🔵 Stop Anticipation");
  if (gameController.eigthFireballLanded) {
    gameData.musicManager.increaseLevel("base");
  }
  // stop all anticipation sounds
  for (let i = 2; i <= 6; i++) {
    soundManager.stop("anticipation" + i);
  }

  if (gameData.reelsSpinning === 0) {
    //this is for after anticipation
    gameData.musicManager.setIdleMusic();
    gameData.musicManager.increaseLevel("base");
  }

  gameController.longSpinParticles.forEach(function (effect) {
    effect.left.gotoAndStop(0);
    effect.left.visible = false;
    effect.right.gotoAndStop(0);
    effect.right.visible = false;
  });
};

gameController.symbolIsFireball = function (symbolId) {
  const symbolsInfo = resourceManager.getConfiguration().symbols;
  return (
    (symbolId >= symbolsInfo["Symbol_Fireball10"].ID &&
      symbolId <= symbolsInfo["Symbol_FireballX2"].ID) ||
    symbolId === 10
  );
};

gameController.SeedUIGenerator = function (UiRandomSeed) {
  gameController.UIRandomSeed = UiRandomSeed;
  gameController.UINumGenerator = gameController.UiGeneratorSplitMix32(
    gameController.UIRandomSeed
  );
};

gameController.UiGeneratorSplitMix32 = function (UiRandomSeed) {
  return function () {
    UiRandomSeed |= 0;
    UiRandomSeed = (UiRandomSeed + 0x9e3779b9) | 0;
    let t = UiRandomSeed ^ (UiRandomSeed >>> 16);
    t = Math.imul(t, 0x21f0aaad);
    t = t ^ (t >>> 15);
    t = Math.imul(t, 0x735a2d97);
    return ((t = t ^ (t >>> 15)) >>> 0) / 4294967296;
  };
};

gameController.doSpin = function (spinTask) {
  console.log("🔵 Do Spin");
  gameData.musicManager.increaseLevel("base");
  gameData.spinData = spinTask.data;
  gameController.spinTask = spinTask;
  gameController.SeedUIGenerator(spinTask.data.uiRandomSeed);

  // Update autoplay button text
  if (resourceManager.getController("autoplayController").Enabled) {
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton",
        String(autoplayManager.getRemainingRounds())
      );
  }

  gameController.isWildFire = spinTask.data.isWildFire;
  gameController.isFbl = spinTask.data.isFbl;
  gameController.isPotBonus = spinTask.data.isPotBonus;
  const stackedReels = spinTask.data.reelsWithStackedWilds;

  if (!spinTask.data.isWildFire && stackedReels.length > 0) {
    let triggeredChancePassed = false;
    const stackedReels = spinTask.data.reelsWithStackedWilds;
    for (
      let index = 0;
      index < stackedReels.length && !triggeredChancePassed;
      index++
    ) {
      const reel = stackedReels[index];
      switch (reel) {
        case 0:
          triggeredChancePassed =
            Math.floor(gameController.UINumGenerator() * 20) > 15;
          break;
        case 1:
          triggeredChancePassed =
            Math.floor(gameController.UINumGenerator() * 20) > 15;
          break;
        case 2:
          triggeredChancePassed =
            Math.floor(gameController.UINumGenerator() * 20) > 17;
          break;
        case 3:
          triggeredChancePassed =
            Math.floor(gameController.UINumGenerator() * 20) > 17;
          break;
        case 4:
          triggeredChancePassed =
            Math.floor(gameController.UINumGenerator() * 20) > 14;
          break;
        case 5:
          triggeredChancePassed =
            Math.floor(gameController.UINumGenerator() * 20) > 13;
          break;
      }
    }
    gameController.isWildFire = triggeredChancePassed;
  }

  gameController.bigWin.hideText();

  gameController.totalWinnings = 0;

  gameController.isPrePaid = spinTask.data.isPrePaidGame;

  gameController.spinHasWin = spinTask.data.totalWinnings;

  gameController.stateMachine.switchState("SPIN_REELS_SPINNING");

  gameData.reelsSpinning = gameData.numReels;

  gameController.longSpinReels = [false, false, false, false, false, false];

  let numBonus = 0;
  let numFireballs = 0;
  const symbolsInfo = resourceManager.getConfiguration().symbols;
  // Set up data for the reels
  let symbols = [];
  let above = [];
  let below = [];
  for (let reel = 0; reel < spinTask.data.resultPanel.reelList.length; reel++) {
    if (numBonus >= gameController.minBonusForFeature - 1) {
      gameController.longSpinReels[reel] = true;
    }
    if (numFireballs >= gameController.minBonusForFeature2Anticipation) {
      gameController.longSpinReels[reel] = true;
    }

    symbols.push([]);
    above.push([]);
    below.push([]);
    for (
      let row = 0;
      row < spinTask.data.resultPanel.reelList[reel].symbols.length;
      row++
    ) {
      const symbolId =
        spinTask.data.resultPanel.reelList[reel].symbols[row].value;
      symbols[reel].push(symbolId);
      // if (symbolId === symbolsInfo["Symbol_Bonus"].ID) {
      //   numBonus++;
      // }
      if (gameController.symbolIsFireball(symbolId)) {
        numFireballs++;
      }
    }
  }

  //Anticipation
  gameController.slotMachine._currentMode.stopDistances =
    gameController.originalStopDistances;
  let newStopDistances = [];
  for (let r = 0; r < gameController.longSpinReels.length; ++r) {
    newStopDistances.push(gameController.originalStopDistances[r]);
    if (gameController.longSpinReels[r] && r > 0) {
      newStopDistances[r - 1] += 20;
    }

    if (stackedReels[r] && r > 0) {
      newStopDistances[r - 1] += 5;
    }
  }

  gameController.slotMachine._currentMode.stopDistances = newStopDistances;

  if (gameController.isWildFire) {
    // for (let index = 0; index < stackedReels.length; index++) {
    //   const reel = stackedReels[index];
    //   gameController.wildFire.play(reel);
    // }

    const self = this;
    if (this.soundNum === 1) {
      this.soundNum = 0;
    } else {
      this.soundNum = 1;
    }
    timerManager.addTimeout(2000, function () {
      soundManager.play(`superWild${self.soundNum}`);
      //gameController.startRedLightning();
      gameController.volcano.play("Volcano_Blow_Short", false, 0, () => {
        let index = 0;
        const fireBallPos = gameController.slotMachine.getSymbolPosition(
          stackedReels[0],
          1
        );

        gameController.reelFireballs[stackedReels[index]][1].landOnReels(
          function () {
            gameController.wildFire.play(stackedReels[index]);
            index++;
            if (stackedReels[index] !== undefined) {
              timerManager.addTimeout(100, function () {
                gameController.sWildCallback(stackedReels, index);
              });
            } else {
              timerManager.addTimeout(50, function () {
                gameController.longSpinReels = [
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                ];
                gameController.slotMachine._currentMode.stopDistances = [
                  0, 0, 0, 0, 0, 0,
                ];
                gameController.spinTaskProcessed = true;
                if (gameController.slamStopped) {
                  gameController.doSlamStop();
                }
              });
            }
          },
          fireBallPos
        );
      });

      // for (let index = 0; index < stackedReels.length; index++) {
      //   const reel = stackedReels[index];
      //   gameController.wildFire.play(reel);
      // }

      gameController.shaker.doShake(2000, function () {
        timerManager.addTimeout(1000, function () {
          gameController.slotMachine.stopReels(
            symbols,
            above,
            below,
            gameController.onSpinComplete
          );
        });
      });
    });
  } else if (gameController.inFreeSpins) {
    const time = 250 * spinTask.data.newActivations.length;
    timerManager.addTimeout(2000 + time, function () {
      gameController.slotMachine.stopReels(
        symbols,
        above,
        below,
        gameController.onSpinComplete
      );
    });
  } else {
    gameController.slotMachine.stopReels(
      symbols,
      above,
      below,
      gameController.onSpinComplete
    );
  }

  gameData.spinData = spinTask.data;
  gameController.spinTask = spinTask;
  gameController.spinTask.join();

  if (gameController.slamStopped && !gameController.isWildFire) {
    gameController.spinTaskProcessed = true;
    gameController.slamReels();
  } else if (!gameController.slamStopped && !gameController.isWildFire) {
    gameController.spinTaskProcessed = true;
  }
};

gameController.initNewSpin = function () {
  timerManager.stop(gameController.cycleWinsDelayTimer);
  console.log("🔵 Init New Spin");
  gameController.reelStopping = [false, false, false, false, false, false];
  gameController.cancelWildTimers();
  gameController.stopAnticipation();
  timerManager.stop(gameController.jackpotBoostTimer);
  gameController.bigWin.Skipped = false;
  gameController.spinTaskProcessed = false;
  gameController.bigWin.skip();

  gameController.reelsAlreadyLanded = [];
  gameController.startNextSpin = false;
  gameController.cachedStart = false;
  gameController.winSkipped = false;
  gameController.spinHasWin = false;
  gameController.jackpotBonusTask = undefined;
  gameController.doBigWinShake = false;

  gameController.animating = false;
  gameController.symbolAnimating = false;
  gameController.symbolAnimator.skip();
  gameController.winlineAnimator.skipAnimation();

  gameController.wildLandAnimator.skip();
  gameController.wildSymbolsToStandOut = [];

  for (
    let index = 0;
    index < gameController.wildLandAnimator._movies.length;
    index++
  ) {
    const trackInfo = gameController.wildLandAnimator._movies[index]._trackInfo;
    trackInfo.showSymbol(true);
  }

  gameController.winControllerMain.skipAnimations();

  const goldenBetButton = resourceManager.get("goldenBetToggleButton");
  goldenBetButton.onSpin();

  timerManager.addTimeout(100, function () {
    gameData.reels.forEach(function (reel) {
      reel.lockFireballCashValues(false);
    });
  });

  gameController.eigthFireballLanded = false;
  gameController.allReelFireballCount = 0;

  gameController.bonusLandSndIndex = 0;

  gameController.bonusSymbolsLanded = 0;
  gameController.fireballsLanded = 0;
  gameController.isWildFire = false;
  gameController.slamStopped = false;
  gameController.playSingleBonus = true;
  gameController.waitingForLandAnim = false;
  gameController.cyclingWins = false;
  gameController.cycleWinsDelayTimer = undefined;
  gameController.bigWin._newSpin = true;
  gameController.bigWin._newSpin = false;
  gameController.lastPayWinsData = undefined;
  gameController.spinComplete = false;
  gameController.longSpinReels = [false, false, false, false, false, false];
  gameController.winningsContainer.visible = true;
  gameData.winningsMeter.set(0);

  soundManager.play("reelSpin");

  gameController.winlineAnimator.skipAnimation();
  gameController.slotMachine.infiniteSpin();
  gameController.setState_WaitingForServer();
  gameController.featurePrize = 0;
  gameController.reelsPrize = 0;

  if (!gameController.inFreeSpins) {
    gameController.stopIdleMusicTimer();

    if (gameData.musicManager.getMusicLevel() === 0) {
      gameData.musicManager.increaseLevel("base");
    }
  }

  timerManager.addTimeout(250, function () {
    for (let reel = 0; reel < gameData.reels.length; reel++) {
      gameData.reels[reel]._lockedCashValues = true;
      for (let row = 0; row < 3; row++) {
        const onBaseGameReelsFireBallText = resourceManager.get(
          `slotContainer:reelContainer:reel${reel}:symbol${row}:symbol_standard:childContainer:fireballCashOverlay`
        );
        const firelinkIndex = reel * 3 + row;
        const onReelsFireballText = resourceManager.get(
          `slotContainer:firelinkFeatureContainer:firelinkFeature:reelGroup${reel}:reel${firelinkIndex}:symbol${0}:symbol:childContainer:fireballCashOverlay`
        );
        onBaseGameReelsFireBallText.modifiedValue = undefined;
        onReelsFireballText.modifiedValue = undefined;
      }
    }
  });
};

gameController.sWildCallback = function (stackedReels, index) {
  const self = this;
  //gameController.wildFire.play(stackedReels[index]);
  const pos = gameController.slotMachine.getSymbolPosition(
    stackedReels[index],
    1
  );
  if (this.soundNum === 1) {
    this.soundNum = 0;
  } else {
    this.soundNum = 1;
  }
  soundManager.play(`superWild${self.soundNum}`);
  gameController.volcano.play("Volcano_Blow_Short", false, 0, () => {
    gameController.reelFireballs[stackedReels[index]][1].landOnReels(
      function () {
        gameController.wildFire.play(stackedReels[index]);
        index++;
        if (stackedReels[index] !== undefined) {
          timerManager.addTimeout(100, function () {
            gameController.sWildCallback(stackedReels, index);
          });
        } else {
          timerManager.addTimeout(50, function () {
            gameController.longSpinReels = [
              false,
              false,
              false,
              false,
              false,
              false,
            ];
            gameController.slotMachine._currentMode.stopDistances =
              gameController.originalStopDistances;
            gameController.spinTaskProcessed = true;
            if (gameController.slamStopped) {
              gameController.doSlamStop();
            }
          });
        }
      },
      pos
    );
  });
};

//////////////////////////////////////////////////
gameController.stopIdleMusicTimer = function () {
  timerManager.stop(gameController.idleMusicTimer);
  gameController.idleMusicTimer = undefined;
};

gameController.initNewGame = function (becauseOfRecovery = false) {
  console.log("🔵 Init New Game");

  gameController.preFSReelPrize = 0;
  gameController.stateMachine.switchState("GAME_PLAYING");
  gameController.slotMachine.update(0);

  gameController.initNewSpin();

  if (resourceManager.getController("autoplayController").Enabled) {
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton",
        String(autoplayManager.getRemainingRounds())
      );
    resourceManager
      .getController("inputOverlord")
      .setText(
        "autoplayCancelButton_portrait",
        String(autoplayManager.getRemainingRounds())
      );
  }
};

gameController.startGame = function () {
  console.log("🔵 Start Game");
  gameController.justHadFreeSpins = false;
  gameController.justHadFbl = false;
  gameController.stoppingAutoplay = false;
  gameController.initNewGame();

  const stakeController = resourceManager.getController("stakeController");
  let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

  gdk.startGame(
    {
      stake: stakeController.CurrentStake,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        buyABonus: false,
        encore: gameData.encoreEnabled,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

gameController.setState_WaitingForServer = function (eventToLeave) {
  if (!gameController.inFreespins) {
    // Only monitor how long we are waiting for server if we arent in freespins
    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }
  if (checkForDefined(eventToLeave)) {
    eventToLeave.leave();
  }
};

gameController.autoplayStarted = function (autoplayData) {
  resourceManager
    .getController("inputOverlord")
    .setText(
      "autoplayCancelButton",
      String(autoplayManager.getRemainingRounds())
    );
};

gameController.autoplayEnded = function (autoplayData) {
  resourceManager
    .getController("inputOverlord")
    .setTranslatonPhrase("autoplayButton", "t_autoplay");
};

StateMachine.Create(gameController);

gameController.stateMachine.addState("WAITING_FOR_LOAD", function () {});

gameController.cancelAutoplay = function () {
  resourceManager.getController("autoplayController").cancel();
};

gameController.stateMachine.addState("WAITING_FOR_START", function () {
  if (gameController.phase.enter()) {
    let animationName = "x" + gameController.currentBlazingMultiplier;
    animationName = animationName.replace(".", "_");
    //If the spine track holds the same animation as the current one, we don't want to play it again.
    if (
      gameController.thermometer.children[0].state.tracks[0].animation.name !=
      animationName
    ) {
      gameController.thermometer.play(animationName, true, 0, undefined);
    }
  }
  if (gameController.phase.timed(300)) {
  }

  if (gameController.phase.hold()) {
    if (!resourceManager.getController("autoplayController").LimitPopupOpen) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    if (
      !autoplayManager.isAutoplayEnabled() &&
      !gameController.justHadFreeSpins &&
      !gameController.startNextSpin &&
      !gameController.justHadFbl
    ) {
      gameController.cyclingWins = true;

      gameController.cycleWinsDelayTimer = timerManager.addTimeout(
        1500,
        function () {
          if (gameController.cyclingWins) {
            gameController.cycleWins();
          }
        }
      );
    }
  }

  if (gameController.phase.hold()) {
    // Waiting for player to do something
    if (autoplayManager.isAutoplayEnabled()) {
      if (
        autoplayManager.AP.getFields()["numberOfRounds"].currentValue !==
        autoplayManager.AP.roundsRemaining()
      ) {
        resourceManager.getController(
          "autoplayController"
        ).timeToNextAutoplay = 500; //dlConst.DELAY_BETWEEN_SPINS;
        gameController.phase.step();
      }
    } else if (gameController.startNextSpin) {
      gameController.phase.step();
    }
  }
  if (!gameController.startNextSpin) {
    if (
      gameController.phase.timed(
        resourceManager.getController("autoplayController").timeToNextAutoplay
      )
    ) {
    }
  }
  if (gameController.phase.once()) {
    if (gameController.stoppingAutoplay) {
      gameController.stoppingAutoplay = false;
      gameController.cancelAutoplay();
    } else {
      gameController.startGame();
    }

    if (autoplayManager.AP.roundsRemaining() === 0) {
      // Last round, so cancel autoplays
      gameController.cancelAutoplay();
    }
  }
});

gameController.stateMachine.addState("RETRIGGER", function () {
  if (gameController.phase.enter()) {
  }

  if (gameController.phase.hold()) {
    if (!soundManager.isSoundPlaying("BellRing")) {
      gameController.phase.step();
    }
  }

  if (gameController.phase.once()) {
    gameController.retriggerTask.leave();
    gameController.retriggerTask = undefined;

    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }
});

//This is to find out when the reels are about to stop spinning and the 3 resulting symbols are about to land.
gameController.stateMachine.addState("SPIN_REELS_SPINNING", function () {
  for (let i = 0; i < gameData.reels.length; i++) {
    if (
      gameData.reels[i]._reelSpinnerData._postInjector
        ._targetSymbolsLeftTilLand < 4 && //there are 3 symbols in a row
      gameController.reelStopping[i] === false
    ) {
      if (!gameController.isWildFire) {
        gameController.reelStopping[i] = true;
      }
    }
  }
});

gameController.stateMachine.addState("WAITING_FOR_SERVER", function () {});

gameController.stateMachine.addState("PAYING_TO_WINNINGS", function () {
  if (gameController.phase.enter()) {
    winMeter.meter.cancelCountUp();
  }

  if (gameController.phase.hold()) {
    if (!gameData.winningsMeter.Props.isCounting) {
      // Finished counting
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible = true;
      }
      gameController.unFadeSymbols();
    } else {
      if (!gameData.slotConfig.promotionActive) {
        resourceManager.get("winningsMeterLabel").visible =
          gameController.gameTime % 200 < 100;
      }
    }
  }

  if (gameController.phase.exit()) {
    if (!gameData.slotConfig.promotionActive) {
      resourceManager.get("winningsMeterLabel").visible = true;
    }
  }
});

gameController.stateMachine.addState("GAME_PLAYING", function () {
  if (gameController.phase.enter()) {
  }
});

gameController.stateMachine.addState("GAME_ENDED", function () {
  if (gameController.phase.enter()) {
    gdk.addTotalGameWinningsToQueue();
    gdk.addBalanceEventToQueue();
  }
  if (gameController.phase.once()) {
    gdk.endGame(function () {
      gameController.stateMachine.switchState("WAITING_FOR_START");
      gameController.baseSpin = true;
    });
  }
});

gameController.stateMachine.switchState("WAITING_FOR_LOAD");

gameController.update = function (delta, time) {
  gameController.stateMachine.update();
};

gameController.cycleWins = function () {
  console.log("🔵 Cycle Wins");

  if (gameController.cyclingWins) {
    if (
      gameController.lastPayWinsData !== undefined &&
      gameController.lastPayWinsData.winningLines !== undefined
    ) {
      gameController.cyclingWinsIndex = 0;
      gameController.cycleWin();
    }
  }
};

gameController.cycleWin = function () {
  console.log("🔵 Cycle Win");

  const stakeController = resourceManager.getController("stakeController");
  gameController.symbolAnimating = true;
  const data =
    gameController.lastPayWinsData.winningLines[
      gameController.cyclingWinsIndex
    ];
  let symbols = [];
  for (let i = 0; i < data.positions.length; ++i) {
    symbols.push({
      cell: { reel: data.positions[i].reel, row: data.positions[i].row },
      symbolId: data.symbol.ids[i],
    });
  }
  let canCelebrate = this.lastPayWinsData.winnings > stakeController.BaseStake;

  gameController.symbolAnimator.animateSymbols(
    symbols,
    gameController.slotMachine,
    canCelebrate,
    false,
    function () {},
    function () {}
  );
  gameController.animating = true;

  gameController.winlineAnimator.playAnimations(
    [
      gameController.lastPayWinsData.winningLines[
        gameController.cyclingWinsIndex
      ],
    ],
    symbols,
    gameController.slotMachine,
    function () {}
  );
  //gameController.winCounter.jumpTo(gameController.lastPayWinsData.winningLines[gameController.cyclingWinsIndex].winAmount);
  //gameController.animateLineWinText();

  timerManager.addTimer(2500, undefined, function () {
    if (gameController.cyclingWins) {
      gameController.animating = false;
      gameController.symbolAnimating = false;
      gameController.symbolAnimator.skip();
      gameController.winlineAnimator.skipAnimation();
      //gameController.winCounter.finish();
      gameController.cycleNextWin();
    }
  });
};

gameController.cycleNextWin = function () {
  if (
    gameController.cyclingWins &&
    !gameController.symbolAnimating &&
    !gameController.animating &&
    gameController.lastPayWinsData &&
    gameController.lastPayWinsData.winningLines
  ) {
    ++gameController.cyclingWinsIndex;
    if (
      gameController.cyclingWinsIndex <
      gameController.lastPayWinsData.winningLines.length
    ) {
      gameController.cycleWin();
    } else {
      gameController.cycleWins();
    }
  }
};

gameController.onLimitsPopupClosed = function () {
  soundManager.play(gameData.sounds.buttonPressed);
  gameController.stateMachine.switchState("GAME_ENDED");
};

// helper function to get the current stake based on game mode
// e.g. base game, buy a bonus, golden bet - don't recalculate here it's returned correctly
gameController.getCurrentModeStake = function (ignoreGoldenBetMultiplier) {
  let stake = 0;
  const stakeController = resourceManager.getController("stakeController");

  if (stakeController) {
    stake = stakeController.getCurrentStake("default");

    if (gameController.inBuyABonus) {
      stake = stakeController.getCurrentStake("BONUS_BUY_LOW");

      if (gameController.buyABonusHigh) {
        stake = stakeController.getCurrentStake("BONUS_BUY_HIGH");
      }
    }

    // in golden bet the fireball values are based on the base stake so multiply down
    let goldenBetButton = resourceManager.get("goldenBetToggleButton");
    if (
      ignoreGoldenBetMultiplier &&
      goldenBetButton !== undefined &&
      goldenBetButton._flags.showGoldenBetActive
    ) {
      stake = stake / gameData.goldenBetMultiplier;
    }
  }
  return stake;
};

gameController.getCurrentModeBaseStake = function (ignoreGoldenBetMultiplier) {
  let stake = 0;
  const stakeController = resourceManager.getController("stakeController");

  if (stakeController) {
    stake = stakeController.getBaseStake("default");

    if (gameController.inBuyABonus) {
      stake = stakeController.getCurrentStake("BONUS_BUY_LOW");

      if (gameController.buyABonusHigh) {
        stake = stakeController.getCurrentStake("BONUS_BUY_HIGH");
      }
    }
  }
  return stake;
};

gameController.onStakeChanged = function (stake) {
  if (stake === undefined) {
    return;
  }

  gameController.updatePots(stake);

  if (gameData.stakeMeter.value !== stake) {
    gameData.reels.forEach(function (reel) {
      reel.lockFireballCashValues(true);
    });

    gameController.winningsContainer.visible = true;

    gameData.stakeMeter.set(stake);

    gameController.cyclingWins = false;
    gameController.lastPayWinsData = undefined;
    gameData.winningsMeter.set(0);
    gdk.playerChangedStake(stake);
  }
  if (Loader.shouldSetStartingSymbols) {
    Loader.shouldSetStartingSymbols = false;
    Loader.setStartingSymbols();
  }
};

gameController.cancelWinlines = function () {
  gameController.winlineAnimator.skipAnimation();
  gameController.cyclingWins = false;
  gameController.lastPayWinsData = undefined;
};

gameController.updatePots = function (stake) {
  const miniPot = resourceManager.get("potContainer:potMini:value");
  const minorPot = resourceManager.get("potContainer:potMinor:value");
  const majorPot = resourceManager.get("potContainer:potMajor:value");
  const ultraPot = resourceManager.get("potContainer:potUltra:value");
  const megaPot = resourceManager.get("potContainer:potMega:value");
  const goldenBetButton = resourceManager.get("goldenBetToggleButton");

  if (
    goldenBetButton !== undefined &&
    goldenBetButton._flags.showGoldenBetActive
  ) {
    stake = stake / gameData.goldenBetMultiplier;
  }

  if (gameController.currentPersistenceState) {
    const currentState = gameController.currentPersistenceState.playerState;
    miniPot.setText(
      gdk.formatCurrency(
        currentState.miniJackpot *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
    minorPot.setText(
      gdk.formatCurrency(
        currentState.minorJackpot *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
    majorPot.setText(
      gdk.formatCurrency(
        currentState.majorJackpot *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
    ultraPot.setText(
      gdk.formatCurrency(
        currentState.ultraJackpot *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
    megaPot.setText(
      gdk.formatCurrency(
        currentState.megaJackpot *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }
};

gameController.onGameComplete = function () {
  console.log("🔵 On Game Complete");

  if (gameController.spinTask.data.totalWinnings > 0) {
    soundManager.play("countUpLoopEnd");
  }

  gameController.freespinsWinnings = 0;
  gameController.stormlinkWinnings = 0;
  gameController.jackpotBonusWinnings = 0;
  gameController.potBonusWinnings = 0;
  gameController.reelsPrize = 0;

  if (
    !autoplayManager.isAutoplayEnabled() &&
    !gameController.freespinsLastSpin
  ) {
    gameController.idleMusicTimer = timerManager.addTimeout(5000, function () {
      gameData.musicManager.fadeLevels(0, "base");
      gameController.idleMusicTimer = undefined;
    });
  }

  if (gameController.inBuyABonus) {
    // restore the original stake
    let stakeController = resourceManager.getController("stakeController");
    stakeController.broadcastCurrentStake("default");
  }

  let goldenBetButton = resourceManager.get("goldenBetToggleButton");
  if (
    goldenBetButton !== undefined &&
    goldenBetButton._flags.showGoldenBetActive
  ) {
    goldenBetButton.glow.visible = true;
  }

  // must do this here else symbols retain the buy a bonus values
  gameController.inBuyABonus = false;
  gameController.stormLinkSkip = true;

  if (gdk.serverParser._inReplayMode) {
    gameController.cyclingWins = true;

    gameController.cycleWinsDelayTimer = timerManager.addTimeout(
      1500,
      function () {
        if (gameController.cyclingWins) {
          gameController.cycleWins();
        }
      }
    );
  }

  gdk.endGame(function () {
    resourceManager.getController("autoplayController").checkLimits();
    // Check again in case we just cancelled autoplay
    if (autoplayManager.isAutoplayEnabled() === false) {
      resourceManager.getController("inputOverlord").setState("enabled");
      gameController.stateMachine.switchState("WAITING_FOR_START");
    } else {
      // Next game is AUTOPLAY
      gameController.stateMachine.switchState("WAITING_FOR_START");
    }
  });
};

gameController.doSlamStop = function () {
  if (gameData.reelsSpinning > 0) {
    gameController.slamStopped = true;
    gameController.reelsToSlam = [];

    for (let i = 0; i < gameController.longSpinReels.length; ++i) {
      gameController.reelsToSlam.push(i);
    }

    gameController.reelStopping = [false, false, false, false, false, false];

    if (gameController.spinTaskProcessed) {
      soundManager.stop("reelSpin");
      gameController.stopAnticipation();
      gameController.slotMachine.slamReels(gameController.reelsToSlam);
    }
  }
};

gameController.finishPayWins = function () {
  console.log("🔵 Finish Pay Wins");
  console.log("Wintask: ");
  console.log(gameController.winTask);

  gameController.slotMachine.dimAllSymbols(false, 0);
};

gameController.initPayWins = function (winTask) {
  console.log("🔵 Init Pay Wins");

  gameController.winTask = winTask;
  gameController.winTask.join();

  gameController.doPayWins(winTask);
};

gameController.doPayWins = function (winTask) {
  let SixOfAKindWins = false;

  gameController.stopAnticipation();
  gameController.reelsPrize = winTask.data.totalLineWinnings;

  for (let index = 0; index < winTask.data.winningLines.length; index++) {
    const winLine = winTask.data.winningLines[index].positions;
    if (winLine.length > 5) {
      SixOfAKindWins = true;
      break;
    }
  }

  if (SixOfAKindWins) {
    gameController.doSixOfAKindWins(winTask);
  } else {
    gameController.doWinAnims(winTask);
  }
};

gameController.doSixOfAKindWins = function (winTask) {
  gameController.SixOfAKindText.visible = true;
  gameController.SixOfAKindRay.visible = true;
  gameController.SixOfAKindContainer.visible = true;
  const sixOfAKindScreenDim = resourceManager.get(
    "slotContainer:jackpotBonusFeatureContainer:dimReelsSixOfAKind"
  );
  sixOfAKindScreenDim.alpha = 0;
  sixOfAKindScreenDim.visible = true;

  gameController.SixOfAKindText.position.y = -800;
  gameController.SixOfAKindRay.position.y = 232;
  gameController.SixOfAKindRay.scale = { x: 0, y: 0 };
  soundManager.play("sixOfAKind");
  const rotationTween = gsap.to(gameController.SixOfAKindRay, {
    duration: 6,
    rotation: Math.PI * 2,
    ease: "linear",
    repeat: -1,
  });

  gsap.to(sixOfAKindScreenDim, {
    duration: 0.2,
    ease: "power1.inOut",
    alpha: 1,
  });

  gsap
    .timeline()
    .to(gameController.SixOfAKindText.position, {
      duration: 0.2,
      ease: "power1.inOut",
      y: 252,
    })
    .to(gameController.SixOfAKindText.position, {
      duration: 0.2,
      ease: "power1.inOut",
      y: 232,
    })
    .to(gameController.SixOfAKindRay.scale, {
      duration: 0.3,
      ease: "power1.inOut",
      y: 1.5,
      x: 1.5,
    })
    .to(gameController.SixOfAKindRay.scale, {
      duration: 0.2,
      ease: "power1.inOut",
      y: 1,
      x: 1,
    })
    .to(gameController.SixOfAKindRay.scale, {
      duration: 1.2,
      ease: "power1.inOut",
      y: 1,
      x: 1,
    })
    .to(gameController.SixOfAKindRay.position, {
      duration: 0.2,
      ease: "power1.inOut",
      y: 202,
      onStart: () => {
        gsap.to(gameController.SixOfAKindRay.position, {
          duration: 0.2,
          ease: "power1.inOut",
          y: 202,
        });
      },
    })
    .to(gameController.SixOfAKindText.position, {
      duration: 0.4,
      ease: "power1.inOut",
      y: 800,
      onStart: () => {
        gsap.to(gameController.SixOfAKindRay.position, {
          duration: 0.4,
          ease: "power1.inOut",
          y: 800,
        });
      },
      onComplete: () => {
        rotationTween.kill();
        gsap.to(sixOfAKindScreenDim, {
          duration: 0.1,
          ease: "power1.inOut",
          alpha: 0,
          onComplete: () => {
            sixOfAKindScreenDim.visible = false;
          },
        });
        gameController.SixOfAKindRay.rotation = 0;
        gameController.SixOfAKindText.visible = false;
        gameController.SixOfAKindRay.visible = false;
        gameController.SixOfAKindContainer.visible = false;
        gameController.doWinAnims(winTask);
      },
    });
};

gameController.winAnim = function (symbol) {
  const filter = new PIXI.filters.ColorMatrixFilter();
  // filter.brightness(2, false);
  symbol.filters = [filter];

  const params = { brightness: 1 };

  const flickerTimeline = gsap.timeline({
    onComplete: () => {
      filter.reset();
      symbol.filters = [];
    },
  });

  const flickerCount = 2;
  const segmentDuration = 4 / flickerCount;

  for (let i = 0; i < flickerCount; i++) {
    const randomBrightness = 2;
    //gsap.utils.random(0.3, 2);

    // Tween to a bright/dim state.
    flickerTimeline.to(params, {
      brightness: randomBrightness,
      duration: segmentDuration / 2,
      ease: "power1.inOut",
      onUpdate: () => {
        // Update the filter’s brightness on each tick.
        // The second parameter (false) means we’re not scaling the current matrix.
        filter.brightness(params.brightness, false);
      },
    });

    flickerTimeline.to(params, {
      brightness: 1,
      duration: segmentDuration / 2,
      ease: "power1.inOut",
      onUpdate: () => {
        filter.brightness(params.brightness, false);
      },
    });
  }
};

gameController.doWinAnims = function (winTask) {
  gameController.reelsPrize = 0;

  // winTask.data.totalLineWinnings === total win and not totalLineWins!

  let symbols = [];
  for (let index = 0; index < winTask.data.winningLines.length; index++) {
    const winLine = winTask.data.winningLines[index].positions;
    gameController.reelsPrize += winTask.data.winningLines[index].winAmount;
    for (let i = 0; i < winLine.length; ++i) {
      symbols.push({
        cell: {
          reel: winLine[i].reel,
          row: winLine[i].row,
        },
        symbolId: winTask.data.winningLines[index].symbol.ids[i],
      });
    }
  }

  if (!gameController.inFreeSpins) {
    gameController.preFSReelPrize = gameController.reelsPrize;
  }

  gameData.winningsMeter.add(gameController.reelsPrize);

  if (gameController.startNextSpin) {
    if (!gameController.bigWin.checkBigWin(gameController.reelsPrize)) {
      timerManager.addTimeout(250, function () {
        gameController.bigWin.start(
          gameController.reelsPrize,
          function () {
            gameController.winlineAnimsDone();
          },
          false,
          true
        );
      });
    }
  } else {
    gameController.lastPayWinsData = winTask.data;

    timerManager.addTimeout(250, function () {
      gameController.animWinsFinished = false;

      gameController.dimNoneWinningSymbols(winTask.data.winningLines);

      gameController.bigWin.start(
        gameController.reelsPrize,
        function () {
          //winlineAnimationController.isAnimating = false;
          gameController.winlinePreAnimsDone();
        },
        false,
        true,
        function () {},
        false,
        false,
        gameController.winSkipped
      );

      gameController.winControllerMain.playAllSymbolAnimations(
        winTask.data,
        symbols,
        gameController.getCurrentModeStake(),
        gameController.slotMachine,
        function () {
          // if (gameController.bigWin.checkBigWin(gameController.reelsPrize)) {
          //   gameController.winlinePreAnimsDone();
          // }
          //winlineAnimationController.isAnimating = false;
        },
        function () {}
      );
    });
  }
};

gameController.dimNoneWinningSymbols = function (winningLines) {
  let winningPositions = [];
  for (let i = 0; i < winningLines.length; ++i) {
    let winningLine = winningLines[i];
    let positions = winningLine.positions;
    for (let j = 0; j < positions.length; ++j) {
      let cell = positions[j];
      winningPositions.push(cell.reel * gameData.numReels + cell.row);
    }
  }

  let symbolsToDim = [];
  for (let reel = 0; reel < gameData.numReels; ++reel) {
    for (let row = 0; row < gameData.numRows; ++row) {
      if (winningPositions.indexOf(reel * gameData.numReels + row) === -1) {
        symbolsToDim.push({ reel: reel, row: row });
      }
    }
  }

  gameController.slotMachine.dimSymbols(symbolsToDim, true, 0.3);
};

gameController.cancelWildTimers = function () {
  gameController.wildTimers.forEach((timer) => {
    timerManager.stop(timer);
  });
};

gameController.winlinePreAnimsDone = function () {
  console.log("🔵 Winline PreAnimsDone");

  //Really hacky fix - I'll come back and do a proper wild animator
  gameController.wildTimers[0] = timerManager.addTimeout(300, function () {
    gameController.wildTimers[1] = timerManager.addTimer(
      2300,
      function () {
        gameController.wildLandAnimator.animateSymbols(
          gameController.wildSymbolsToStandOut,
          gameController.slotMachine,
          true,
          true,
          function () {}
        );
      },
      function () {}
    );
  });

  // if (!gameController.bigWin.checkBigWin(gameController.reelsPrize)) {
  //   gameController.bigWin.start(
  //     gameController.reelsPrize,
  //     function () {
  //       //winlineAnimationController.isAnimating = false;
  //       gameController.winlineAnimsDone();
  //     },
  //     false,
  //     true,
  //     function () {},
  //     false,
  //     false,
  //     gameController.winSkipped
  //   );
  // } else {
  //   gameController.winlineAnimsDone();
  // }

  gameController.winlineAnimsDone();
};

gameController.winlineAnimsDone = function () {
  console.log("🔵 Winline Anims Done");

  gameController.redrawSymbols(gameController.slotMachine);
  gameController.finishPayWins();

  console.log("Wintask: ");
  console.log(gameController.winTask);

  gameController.animWinsFinished = true;
  if (gameController.winTask) {
    gameController.winTask.leave();
    gameController.winTask = undefined;
  }
};

gameController.skipWinAnimations = function () {
  gameController.bigWin.skip(gameController.winlineAnimsDone);
  gameController.winControllerMain.skipAnimations();
};

gameController.isAnimatingWins = function () {
  return gameController.winTask !== undefined;
};

gameController.skip = function () {
  gameController.winSkipped = true;
  gameController.slotMachine.dimAllSymbols(false, 0);
  gameController.winControllerMain.skipAnimations();
  gameController.winlineAnimator.skipAnimation();
  gameController.bigWin.skip();
  //gameController.winlineAnimsDone();
};

gameController.skipWin = function () {
  gameController.skip();
  gameController.startNextSpin = true;
};

gameController.freespinsComplete = function (value) {
  gameController.reelsPrize = gameController.preFSReelPrize;
  gameController.featurePrize = value;
  gameController.stateMachine.switchState("IDLE");
};

gameController.onFreespinsStart = function () {
  autoplayManager.stopAutoplay();
};

gameController.onFreespinsEnd = function () {
  gameController.justHadFreeSpins = true;
  gameController.inFreeSpins = false;
};

gameController.recoverGame = function (task) {
  gameController.wildLandAnimator.skip();
  gameController.redrawSymbols(gameController.slotMachine);
  gameData.musicManager.onRestorePreviouslyPlayingAudio(task);
  gameController.gameRecovering = true;

  // Recovery game with encore
  if (
    task.data.metaData === "encore" &&
    gameData.encoreEnabled !== task.data.metaValue
  ) {
    // Clear any encore effects and stop them appearing again
    gameData.encoreEnabled = task.data.metaValue;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get("goldenBetToggleButton");

    if (encoreButtonLB._flags.showGoldenBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }
  }

  if (
    (task.data.metaData === "buyABonusFireBall" ||
      task.data.metaData === "buyABonusFreeSpins") &&
    task.data.metaValue
  ) {
    let stakeController = resourceManager.getController("stakeController");

    let baseStake = gameData.recoveryStake;

    let stakes = stakeController.Stakes;
    let returnStake = stakes.find((stake) => stake === baseStake);

    if (!returnStake) {
      returnStake = stakes[0];
    }

    stakeController.requestChangeStake(returnStake);

    gameData.stakeMeter.set(baseStake);

    gameController.inBuyABonus = true;
    gameController.buyABonusHigh =
      task.data.metaData === "buyABonusFireBall" ? false : true;

    if (gameController.buyABonusHigh) {
      stakeController.requestChangeStake(baseStake, "BONUS_BUY_HIGH");
    } else {
      stakeController.requestChangeStake(baseStake, "BONUS_BUY_LOW");
    }
    gameController.initNewGame(true);
    gameController.inBuyABonus = true;
  } else {
    gameController.initNewGame(true);

    // Update stake
    let stakeController = resourceManager.getController("stakeController");
    // FUTURE REFERENCE - If recovery doesn't have a base stake set make sure you have restorePreviousWagersDerived defined
    let baseStake = stakeController.BaseStake;
    let goldenBetEnabled = gameData.encoreEnabled;

    stakeController.setStakeMultiplier(
      goldenBetEnabled ? gameData.goldenBetMultiplier : 1
    );
    gameController.onStakeChanged(
      baseStake * (goldenBetEnabled ? gameData.goldenBetMultiplier : 1)
    );
    stakeController.broadcastCurrentStake();

    gameController.updatePots(baseStake);
  }
};

gameController.onAbortGame = function () {
  soundManager.stop("reelsSpin");

  gameController.slotMachine.abortSpin();

  for (let index = 0; index < gameData.reels.length; index++) {
    const reel = gameData.reels[index];
    reel._reelSpinnerData._reelSpinning = false;
  }

  Loader.setStartingSymbols();

  gameController.redrawSymbols(gameController.slotMachine);
};

gameController.onOrientationChange = function () {
  if (gameController.chevronMoviePlaying) {
    const newPosition = gameController.blazingMultiplierContainer.toLocal(
      gameController.extraHotSymbolStartingPos.toGlobal(systemData.stage)
    );
    gameController.chevronMovie.position = newPosition;
  }
  if (gameController.showingExtraHot) {
    const newPosition = gameController.blazingMultiplierContainer.toLocal(
      gameController.extraHotSymbolStartingPos.toGlobal(systemData.stage)
    );
    gameController.extraHotSymbol.position = newPosition;
  }
  if (gameController.extraHotParticleXTween != null) {
    gameController.extraHotParticleXTween.progress(1);
  }
  if (gameController.extraHotParticleYTween != null) {
    gameController.extraHotParticleYTween.progress(1);
  }
};

gameController.onfireballLinkStartEvent = function () {
  gameController.cancelAutoplay();
  gameController.inFirelink = true;
};

gameController.onRetriggering = function (task) {
  console.log("🔵 On Retriggering");

  gameController.retriggerTask = task;
  gameController.retriggerTask.join();

  soundManager.play("BellRing");
  gameController.stateMachine.switchState("RETRIGGER");
};

gameController.onfireballLinkEndEvent = function () {
  gameController.inFirelink = false;
  gameController.justHadFbl = true;
};

gameController.onFireballsLandedEvent = function (task) {
  console.log("🔵 On Firebals Landed Event");

  if (task.data.pauseExecution) {
    task.join();
  }

  const symbols = resourceManager.getConfiguration().symbols;
  const firstCashFireballId = symbols["Symbol_Fireball10"].ID;
  //const fireBalls = task.data.fireballs;
  const fireBalls = [];

  for (let reel = 0; reel < gameData.reels.length; reel++) {
    for (let row = 0; row < 3; row++) {
      let symID = gameController.slotMachine.getSymbolId(reel, row);
      if (symID >= firstCashFireballId && symID < 42) {
        fireBalls.push({
          coord: {
            row: row,
            reel: reel,
          },
          symID: symID,
        });
      }
    }
  }

  let count = fireBalls.length;

  if (count <= 0) {
    console.log("There are no fireballs to shoot up into the Volcano.");
    timerManager.addTimeout(1, function () {
      task.leave(); //Delay to stop a stupid race condition occuring?! Why do we have to do this it's so dumb!
    });
    return;
  }
  gameController.volcanoAnimLocked = true;
  //let slotMachine = resourceManager.getController("SlotMachine");
  fireBalls.forEach(function (fireball, index) {
    const reel = fireball.coord.reel;
    const row = fireball.coord.row;
    const fireBallPos = gameController.slotMachine.getSymbolPosition(reel, row);
    //const isFlbFireball = fireball.fblFireball;
    const isFirst = index === 0; //to play sound only once

    gameController.reelFireballs[reel][row].animate(
      false,
      function () {
        count--;
        if (count <= 0) {
          soundManager.play("fireballWhooshDown");
          let animationName = "Volcano_Hit";
          if (fireBalls.length > 1) {
            animationName += "_" + fireBalls.length;
          }

          if (fireBalls.length >= 12) {
            animationName = "Volcano_Hit_12";
          }
          gameController.volcano.spineObject.stateData.defaultMix = 0;
          gameController.volcano.play(animationName, false, 0, () => {
            //If the spine track holds the same animation as the current one, we don't want to play it again.
            if (task.data.isJackpotComingUp) {
              gameController.shaker.doShake(2000);
            }
            if (task.data.pauseExecution) {
              task.leave();
            }
            gameController.volcanoAnimLocked = false;
            gameController.volcano.spineObject.stateData.defaultMix = 0.1;
            gameController.updateVolcanoLevel(
              gameController.currentVolcanoLevel,
              true
            );
          });
        }
      },
      fireBallPos,
      isFirst
    );
  });
};

gameController.updateVolcanoLevel = function (level, playAnim = true) {
  gameController.currentVolcanoLevel = level;
  if (level >= 0 && level < 3) {
    gameController.volcanoParticle.particleEmitter.emit = false;
    gameController.volcanoSmoke.visible = false;
  } else if (level >= 3 && level < 5) {
    gameController.volcanoParticle.particleEmitter.emit = true;
    gameController.volcanoParticle.particleEmitter.frequency = 0.08;
    gameController.volcanoParticle.particleEmitter.startSpeed.value = 122;
    gameController.volcanoParticle.particleEmitter.minimumSpeedMultiplier = 1.11;
    gameController.volcanoSmoke.visible = false;
  } else if (level >= 5 && level < 7) {
    gameController.volcanoParticle.particleEmitter.emit = true;
    gameController.volcanoParticle.particleEmitter.frequency = 0.031;
    gameController.volcanoParticle.particleEmitter.startSpeed.value = 122;
    gameController.volcanoParticle.particleEmitter.minimumSpeedMultiplier = 1.11;
    gameController.volcanoSmoke.visible = true;
    gameController.volcanoSmoke.play();
    gameController.volcanoSmoke.alpha = 0.4;
  } else if (level >= 7 && level < 9) {
    gameController.volcanoParticle.particleEmitter.emit = true;
    gameController.volcanoParticle.particleEmitter.frequency = 0.019;
    gameController.volcanoParticle.particleEmitter.startSpeed.value = 122;
    gameController.volcanoParticle.particleEmitter.minimumSpeedMultiplier = 1.11;
    gameController.volcanoSmoke.visible = true;
    gameController.volcanoSmoke.play();
    gameController.volcanoSmoke.alpha = 0.8;
  } else if (level == 9) {
    gameController.volcanoParticle.particleEmitter.emit = true;
    gameController.volcanoParticle.particleEmitter.frequency = 0.019;
    gameController.volcanoParticle.particleEmitter.startSpeed.value = 150;
    gameController.volcanoParticle.particleEmitter.minimumSpeedMultiplier = 1.24;
    gameController.volcanoSmoke.visible = true;
    gameController.volcanoSmoke.play();
    gameController.volcanoSmoke.alpha = 0.9;
  } else if (level >= 10) {
    gameController.volcanoParticle.particleEmitter.emit = true;
    gameController.volcanoParticle.particleEmitter.frequency = 0.005;
    gameController.volcanoParticle.particleEmitter.startSpeed.value = 176;
    gameController.volcanoParticle.particleEmitter.minimumSpeedMultiplier = 1.42;
    gameController.volcanoSmoke.visible = true;
    gameController.volcanoSmoke.play();
    gameController.volcanoSmoke.alpha = 0.9;
  }

  //If the spine track holds the same animation as the current one, we don't want to play it again.
  if (
    gameController.volcano.children[0].state.tracks[0].animation.name !=
      "Volcano_Intensity_" + level &&
    playAnim
  ) {
    console.log("Playing: " + "Volcano_Intensity_" + level);
    gameController.volcano.play(
      "Volcano_Intensity_" + level,
      true,
      0,
      undefined
    );
  }
};

gameController.onFireballLinkEndEvent = function () {};

gameController.updateCreditMeter = function () {
  if (
    !gameController.isPrePaid &&
    !gameController.gameRecovering &&
    !gdk.serverParser._inReplayMode
  ) {
    gameData.creditMeter.set(
      gameData.credit +
        gameController.reelsPrize +
        gameController.freespinsWinnings +
        gameController.stormlinkWinnings +
        gameController.potBonusWinnings +
        gameController.jackpotBonusWinnings
    );
  }
};

gameController.onEndOfBaseGameSpinEvent = function (task) {
  console.log("🔵 On End Of Base Game Spin Event");

  if (gameController.bigWin.checkBigWin(task.data.totalWin)) {
    task.join();
    gameController.startNextSpin = false;
    gameController.bigWin.start(
      task.data.totalWin,
      function () {
        gameController.nightBackground.visible = false;
        gameController.nightBackgroundPortrait.visible = false;
        gameController.updateCreditMeter();
        task.leave();
      },
      true,
      false,
      function () {},
      false,
      task.data.isCapped
    );
  } else {
    gameController.updateCreditMeter();
    if (gameController.nightBackground.visible) {
      timerManager.addTimer(
        500,
        function (progress) {
          gameController.nightBackground.alpha = 1 - progress;
        },
        function () {
          gameController.nightBackground.alpha = 1;
          gameController.nightBackground.visible = false;
        }
      );
    }
    if (gameController.nightBackgroundPortrait.visible) {
      timerManager.addTimer(
        500,
        function (progress) {
          gameController.nightBackgroundPortrait.alpha = 1 - progress;
        },
        function () {
          gameController.nightBackgroundPortrait.alpha = 1;
          gameController.nightBackgroundPortrait.visible = false;
        }
      );
    }
  }
};

gameController.setCachedStart = function () {
  gameController.cachedStart = true;
  gameController.startNextSpin = true;
  if (gameController.isAnimatingWins()) {
    gameController.shaker.skip();
    gameController.skipWin();
  }
};

gameController.onPotBonusEndEvent = function (task) {
  gameController.preFSReelPrize += task.winAmount;
};

gameController.doJackpotBoost = function (task = undefined) {
  if (task !== undefined && task.data.pauseExecution) {
    task.join();
  }
  console.log("🔵 Jackpot Boost");

  gameController.jackpotBoost = task.data.boosts;
  gameController.jackpotBonusTask = task;
  //TODO: clear this up! We really shouldn't have to keep 'getting' the pots.
  const miniPot = resourceManager.get("potContainer:potMini:value");
  const minorPot = resourceManager.get("potContainer:potMinor:value");
  const majorPot = resourceManager.get("potContainer:potMajor:value");
  const ultraPot = resourceManager.get("potContainer:potUltra:value");
  const megaPot = resourceManager.get("potContainer:potMega:value");
  const miniPotMovie = resourceManager.get("potContainer:potMini:miniMovie");
  const minorPotMovie = resourceManager.get("potContainer:potMinor:minorMovie");
  const majorPotMovie = resourceManager.get("potContainer:potMajor:majorMovie");
  const ultraPotMovie = resourceManager.get("potContainer:potUltra:ultraMovie");
  const megaPotMovie = resourceManager.get("potContainer:potMega:megaMovie");
  //task.join();
  const boosts =
    task === undefined ? gameController.jackpotBoost : task.data.boosts;
  let isHit = false;
  if (boosts) {
    if (task === undefined) {
      gameController.jackpotBoost = undefined;
    }
    for (let index = 0; index < boosts.length; index++) {
      if (!isHit) {
        isHit = true;
        soundManager.play("jpIncrease");
      }
      const boost = boosts[index];
      console.log(
        "Jackpot: " +
          boost.jackpotSymbol +
          "  Amount: " +
          boost.amount +
          "  New Value: " +
          boost.newValue
      );
      switch (boost.jackpotSymbol) {
        case "Mini":
          miniPotMovie.visible = true;
          miniPotMovie.gotoAndStop(0);
          timerManager.addTimer(
            600,
            undefined,
            gameController.jackpotValueBoostUpdateValue.bind(
              this,
              miniPot,
              boost
            )
          );
          miniPotMovie.play();
          break;
        case "Minor":
          minorPotMovie.visible = true;
          minorPotMovie.gotoAndStop(0);
          timerManager.addTimer(
            600,
            undefined,
            gameController.jackpotValueBoostUpdateValue.bind(
              this,
              minorPot,
              boost
            )
          );
          minorPotMovie.play();
          break;
        case "Major":
          majorPotMovie.visible = true;
          majorPotMovie.gotoAndStop(0);
          timerManager.addTimer(
            600,
            undefined,
            gameController.jackpotValueBoostUpdateValue.bind(
              this,
              majorPot,
              boost
            )
          );
          majorPotMovie.play();
          break;
        case "Ultra":
          ultraPotMovie.visible = true;
          ultraPotMovie.gotoAndStop(0);
          timerManager.addTimer(
            600,
            undefined,
            gameController.jackpotValueBoostUpdateValue.bind(
              this,
              ultraPot,
              boost
            )
          );
          ultraPotMovie.play();
          break;
        case "Mega":
          megaPotMovie.visible = true;
          megaPotMovie.gotoAndStop(0);
          timerManager.addTimer(
            600,
            undefined,
            gameController.jackpotValueBoostUpdateValue.bind(
              this,
              megaPot,
              boost
            )
          );
          megaPotMovie.play();
          break;
      }
    }
  }

  if (gameController.jackpotBonusTask !== undefined) {
    gameController.jackpotBoostTimer = timerManager.addTimer(
      2000,
      undefined,
      () => {
        if (gameController.jackpotBonusTask !== undefined) {
          gameController.jackpotBonusTask.leave();
          gameController.jackpotBonusTask = undefined;
        }
      }
    );
  }

  //task.leave();
};

gameController.jackpotValueBoostUpdateValue = function (potValue, boost) {
  let stakeController = resourceManager.getController("stakeController");
  let stake = stakeController.getBaseStake("default");
  stake = gameController.getCurrentModeBaseStake(true);

  let yPos = 0;
  let scaleValue = 1.15;
  scaleValue = potValue.scale.x * 1.2;

  if (
    potValue.name.includes("potUltra") ||
    potValue.name.includes("potMajor")
  ) {
    yPos = 12;
  } else if (potValue.name.includes("potMega")) {
    yPos = 14;
    //scaleValue = potValue.scale.x * 1.2;
  } else {
    yPos = 8;
  }

  potValue.setText(
    gdk.formatCurrency(
      boost.newValue * (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );

  gsap.timeline().to(potValue.position, {
    duration: 0.2,
    ease: "circ.out",
    y: -yPos,
    onStart: () => {
      gsap.to(potValue.scale, {
        duration: 0.3,
        x: scaleValue,
        y: scaleValue,
        repeat: 1,
        yoyo: true,
      });
    },
    onComplete: () => {
      gsap
        .timeline()
        .to(potValue.position, {
          duration: 0.1,
        })
        .to(potValue.position, {
          duration: 0.2,
          ease: "circ.out",
          y: 14,
        })
        .to(potValue.position, {
          duration: 0.2,
          ease: "circ.out",
          y: yPos,
        });
    },
  });
};

gameController.updatePeristenceState = function (task) {
  console.log("🔵 Persistence Update: Set Persistence State");
  gameController.currentPersistenceState = task.data.persitenceState;
};

gameController.updateToInitialPersistenceState = function (task = undefined) {
  let stake = gameController.getCurrentModeBaseStake(true);

  const miniPot = resourceManager.get("potContainer:potMini:value");
  const minorPot = resourceManager.get("potContainer:potMinor:value");
  const majorPot = resourceManager.get("potContainer:potMajor:value");
  const ultraPot = resourceManager.get("potContainer:potUltra:value");
  const megaPot = resourceManager.get("potContainer:potMega:value");

  if (task !== undefined) {
    gameController.currentPersistenceState = task.data.persitenceState;
  }

  const initialState =
    gameController.currentPersistenceState.initialPlayerState;

  miniPot.setText(
    gdk.formatCurrency(
      initialState.miniJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  minorPot.setText(
    gdk.formatCurrency(
      initialState.minorJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  majorPot.setText(
    gdk.formatCurrency(
      initialState.majorJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  ultraPot.setText(
    gdk.formatCurrency(
      initialState.ultraJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  megaPot.setText(
    gdk.formatCurrency(
      initialState.megaJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );

  gameController.blazingMultiplierValue.setText(
    "X" + initialState.blazingBountyMultiplier
  );
  gameController.currentBlazingMultiplier = parseFloat(
    initialState.blazingBountyMultiplier
  );
  let animationName = "x" + gameController.currentBlazingMultiplier;
  animationName = animationName.replace(".", "_");
  //If the spine track holds the same animation as the current one, we don't want to play it again.
  if (
    gameController.thermometer.children[0].state.tracks[0].animation.name !=
    animationName
  ) {
    gameController.thermometer.play(animationName, true, 0, undefined);
  }

  if (initialState.bonusBuyCeleberation) {
    // Do bonus buy animation to show the user the value has changed.
  }
};

gameController.updateToEndOfSpinPersistenceState = function (task = undefined) {
  console.log("🔵 Persistence Update: Set Persistence to End Of Spin Values");
  const miniPot = resourceManager.get("potContainer:potMini:value");
  const minorPot = resourceManager.get("potContainer:potMinor:value");
  const majorPot = resourceManager.get("potContainer:potMajor:value");
  const ultraPot = resourceManager.get("potContainer:potUltra:value");
  const megaPot = resourceManager.get("potContainer:potMega:value");
  let stake = gameController.getCurrentModeBaseStake(true);

  if (task !== undefined) {
    gameController.currentPersistenceState = task.data.persitenceState;
  }

  const endOfSpinState = gameController.currentPersistenceState.playerState;
  miniPot.setText(
    gdk.formatCurrency(
      endOfSpinState.miniJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  minorPot.setText(
    gdk.formatCurrency(
      endOfSpinState.minorJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  majorPot.setText(
    gdk.formatCurrency(
      endOfSpinState.majorJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  ultraPot.setText(
    gdk.formatCurrency(
      endOfSpinState.ultraJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  megaPot.setText(
    gdk.formatCurrency(
      endOfSpinState.megaJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );

  gameController.blazingMultiplierValue.setText(
    "X" + endOfSpinState.blazingBountyMultiplier
  );
  if (
    gameController.currentBlazingMultiplier !==
    endOfSpinState.blazingBountyMultiplier
  ) {
    gameController.currentBlazingMultiplier = parseFloat(
      endOfSpinState.blazingBountyMultiplier
    );
    let animationName = "x" + gameController.currentBlazingMultiplier;
    animationName = animationName.replace(".", "_");
    //If the spine track holds the same animation as the current one, we don't want to play it again.
    if (
      gameController.thermometer.children[0].state.tracks[0].animation.name !=
      animationName
    ) {
      gameController.thermometer.play(animationName, true, 0, undefined);
    }
  }

  console.log(gameController.volcanoAnimLocked);
  gameController.currentVolcanoLevel = endOfSpinState.volcanoLevel;

  if (!gameController.volcanoAnimLocked) {
    gameController.updateVolcanoLevel(endOfSpinState.volcanoLevel, true);
  }
};

gameController.SetIntialPersistenceValues = function (task) {
  const miniPot = resourceManager.get("potContainer:potMini:value");
  const minorPot = resourceManager.get("potContainer:potMinor:value");
  const majorPot = resourceManager.get("potContainer:potMajor:value");
  const ultraPot = resourceManager.get("potContainer:potUltra:value");
  const megaPot = resourceManager.get("potContainer:potMega:value");
  let stake = gameController.getCurrentModeBaseStake(true);

  if (task !== undefined) {
    gameController.currentPersistenceState = task.data.persitenceState;
  }

  if (gameController.potsRecovered) {
    gameController.potsRecovered = false;
    return;
  }

  const initialState =
    gameController.currentPersistenceState.initialPlayerState;
  miniPot.setText(
    gdk.formatCurrency(
      initialState.miniJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  minorPot.setText(
    gdk.formatCurrency(
      initialState.minorJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  majorPot.setText(
    gdk.formatCurrency(
      initialState.majorJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  ultraPot.setText(
    gdk.formatCurrency(
      initialState.ultraJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );
  megaPot.setText(
    gdk.formatCurrency(
      initialState.megaJackpot *
        (stake / gameData.gameConfig.winLinesForCashConversion)
    )
  );

  gameController.blazingMultiplierValue.setText(
    "X" + initialState.blazingBountyMultiplier
  );
  gameController.currentBlazingMultiplier = parseFloat(
    initialState.blazingBountyMultiplier
  );
};

gameController.overrideStartingPersistenceValues = function (task) {
  console.log("🔵 Persistence OVERRIDE: Set Persistence to Intial Values");
  const miniPot = resourceManager.get("potContainer:potMini:value");
  const minorPot = resourceManager.get("potContainer:potMinor:value");
  const majorPot = resourceManager.get("potContainer:potMajor:value");
  const ultraPot = resourceManager.get("potContainer:potUltra:value");
  const megaPot = resourceManager.get("potContainer:potMega:value");
  let stake = gameController.getCurrentModeBaseStake(true);

  const data = task.data;

  if (data.miniJackpotAtGameStart) {
    miniPot.setText(
      gdk.formatCurrency(
        data.miniJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }
  if (data.minorJackpotAtGameStart) {
    minorPot.setText(
      gdk.formatCurrency(
        data.minorJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }
  if (data.majorJackpotAtGameStart) {
    majorPot.setText(
      gdk.formatCurrency(
        data.majorJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }
  if (data.ultraJackpotAtGameStart) {
    ultraPot.setText(
      gdk.formatCurrency(
        data.ultraJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }
  if (data.megaJackpotAtGameStart) {
    megaPot.setText(
      gdk.formatCurrency(
        data.megaJackpotAtGameStart *
          (stake / gameData.gameConfig.winLinesForCashConversion)
      )
    );
  }

  if (data.blazingMultiplierAtGameStart) {
    gameController.blazingMultiplierValue.setText(
      "X" + data.blazingMultiplierAtGameStart
    );

    if (
      gameController.currentBlazingMultiplier !==
      data.blazingMultiplierAtGameStart
    ) {
      gameController.currentBlazingMultiplier = parseFloat(
        data.blazingMultiplierAtGameStart
      );
      let animationName = "x" + gameController.currentBlazingMultiplier;
      animationName = animationName.replace(".", "_");
      //If the spine track holds the same animation as the current one, we don't want to play it again.
      if (
        gameController.thermometer.children[0].state.tracks[0].animation.name !=
        animationName
      ) {
        gameController.thermometer.play(animationName, true, 0, undefined);
      }
    }
  }
};

gameController.doMultiplierBoost = function (task) {
  console.log("🔵 Multiplier Boost");
  gameController.multiplierBoostTask = task;
  task.join();
  gameController.newBlazingMultiplier = task.data.multiplier;

  gameController.extraHotSymbol.gotoAndStop(0);
  gameController.extraHotSymbol.position = { x: 1080, y: 418 };
  const reelContainer = resourceManager.get("slotContainer:reelContainer");
  const originalIndex =
    reelContainer.children[0].getChildIndex(gameController.chevronMovie) + 1;
  soundManager.play("extraHotTransition");
  const moveExtraHotToThermometer = () => {
    gameController.fireParticle.particleEmitter.emit = true;
    const pos = gameController.slotMachine.getSymbolPosition(5, 1);

    gameController.fireParticle.particleEmitter.spawnPos = pos;
    gameController.fireParticle.visible = true;
    gameController.fireParticle.particleEmitter.spawnPos.y += 60;

    const landscapePos = {
      x:
        gameController.blazingMultiplierContainer.position.x +
        gameController.blazingMultiplierValue.position.x +
        20,
      y:
        gameController.blazingMultiplierContainer.position.y +
        gameController.blazingMultiplierValue.position.y +
        40,
    };
    const portraitPos = { x: 995, y: -165 };
    const endParticlePos = layoutController
      .getCurrentLayout()
      .includes("portrait")
      ? portraitPos
      : landscapePos;
    gameController.extraHotParticleXTween = gsap.to(
      gameController.fireParticle.particleEmitter.spawnPos,
      {
        duration: 0.2,
        ease: "power1.in",
        x: endParticlePos.x,
        onComplete: () => {
          gameController.extraHotParticleXTween = null;
        },
      }
    );
    gameController.extraHotParticleYTween = gsap.to(
      gameController.fireParticle.particleEmitter.spawnPos,
      {
        duration: 0.5,
        ease: "power1.inOut",
        y: endParticlePos.y,
        onComplete: () => {
          gameController.extraHotParticleYTween = null;
          gameController.fireParticle.particleEmitter.emit = false;
          gameController.fireParticle.visible = false;
        },
      }
    );

    gsap.to(gameController.extraHotSymbol.scale, {
      duration: 0.5,
      ease: "power1.out",
      x: 0.6,
    });
    gsap.to(gameController.extraHotSymbol.scale, {
      duration: 0.5,
      ease: "elastic.out(1.5,1)",
      y: 0.6,
    });

    gameController.extraHotMoveXProgress = 0;
    gsap.to(gameController, {
      extraHotMoveXProgress: 100,
      duration: 0.2,
      ease: "power1.out",
      onUpdate: () => {
        const startingX = gameController.blazingMultiplierContainer.toLocal(
          gameController.extraHotSymbolStartingPos.toGlobal(systemData.stage)
        ).x;
        const xDiff =
          ((70 - startingX) * gameController.extraHotMoveXProgress) / 100;
        gameController.extraHotSymbol.x = startingX + xDiff;
      },
    });
    gameController.extraHotMoveYProgress = 0;
    gsap.to(gameController, {
      extraHotMoveYProgress: 100,
      duration: 0.5,
      ease: "power1.inOut",
      onUpdate: () => {
        const startingY = gameController.blazingMultiplierContainer.toLocal(
          gameController.extraHotSymbolStartingPos.toGlobal(systemData.stage)
        ).y;
        const yDiff =
          ((55 - startingY) * gameController.extraHotMoveYProgress) / 100;
        gameController.extraHotSymbol.y = startingY + yDiff;
      },
      onComplete: () => {
        gameController.blazingMultiplierFlame.visible = true;
        gameController.blazingMultiplierFlame.gotoAndStop(0);
        gameController.blazingMultiplierFlame.play();
        gameController.blazingMultiplierFlame.onComplete = () => {
          gameController.blazingMultiplierFlame.visible = false;
          gameController.fireParticle.particleEmitter.emit = false;
          gameController.multiplierAfterExtraHotTravelsTo();
        };
        timerManager.addTimeout(500, () => {
          gameController.currentBlazingMultiplier += 0.5;
          gameController.currentBlazingMultiplier =
            gameController.currentBlazingMultiplier > 5
              ? 5
              : gameController.currentBlazingMultiplier;
          gameController.blazingMultiplierValue.setText(
            "X" + gameController.currentBlazingMultiplier
          );
          gsap.to(gameController.blazingMultiplierValue.scale, {
            delay: 0.2,
            x: 1.2,
            y: 1.2,
            duration: 0.4,
            yoyo: true,
            repeat: 1,
          });
        });
        timerManager.addTimeout(200, () => {
          gameController.extraHotSymbol.visible = false;
          reelContainer.children[0].addChildAt(
            gameController.extraHotSymbol,
            originalIndex
          );
          gameController.extraHotSymbol.scale.set(1, 1);
        });
      },
    });
  };

  const showExtraHot = () => {
    gameController.showingExtraHot = true;

    gameController.extraHotSymbol.visible = true;
    gameController.extraHotSymbol.scale = { x: 0, y: 0 };
    gameController.extraHotSymbol.onComplete = () => {
      gameController.showingExtraHot = false;
      moveExtraHotToThermometer();
    };

    const newStartPosition = gameController.blazingMultiplierContainer.toLocal(
      gameController.extraHotSymbolStartingPos.toGlobal(systemData.stage)
    );
    gameController.extraHotSymbol.position = newStartPosition;

    gameController.blazingMultiplierContainer.children[0].addChildAt(
      gameController.extraHotSymbol,
      4
    );

    gsap
      .timeline()
      .to(gameController.extraHotSymbol, {
        duration: 0.3,
        ease: "power1.out",
        pixi: { scale: 1.2 },
      })
      .to(gameController.extraHotSymbol, {
        pixi: { scale: 1 },
        duration: 0.1,
        ease: "power1.out",
        onComplete: () => {
          gameController.extraHotSymbol.gotoAndStop(0);
          gameController.extraHotSymbol.play();
        },
      });
  };

  gameController.chevronMovie.visible = true;
  gameController.chevronMovie.gotoAndStop(0);

  showExtraHot();
  timerManager.addTimeout(500, () => {
    const orgPos = {
      x: gameController.chevronMovie.position.x,
      y: gameController.chevronMovie.position.y,
    };

    const newStartPosition = gameController.blazingMultiplierContainer.toLocal(
      gameController.extraHotSymbolStartingPos.toGlobal(systemData.stage)
    );
    gameController.chevronMovie.position = newStartPosition;

    gameController.blazingMultiplierContainer.children[0].addChildAt(
      gameController.chevronMovie,
      4
    );
    gameController.chevronMovie.onComplete = () => {
      gameController.chevronMoviePlaying = false;
      reelContainer.children[0].addChildAt(
        gameController.chevronMovie,
        originalIndex - 1
      );
      gameController.chevronMovie.position = orgPos;
    };
    gameController.chevronMovie.play();
    gameController.chevronMoviePlaying = true;
  });
};

gameController.multiplierAfterExtraHotTravelsTo = function () {
  console.log("🔵 Multiplier Boost");

  let animationName = `x${gameController.currentBlazingMultiplier - 0.5} Up`;
  animationName = animationName.replace(".", "_");
  //If the spine track holds the same animation as the current one, we don't want to play it again.
  if (
    gameController.thermometer.children[0].state.tracks[0].animation.name !=
    animationName
  ) {
    gameController.thermometer.play(animationName, false, 0, () => {
      gameController.spineMultiplierIncrease();
    });
  }
};

gameController.spineMultiplierIncrease = function () {
  gameData.musicManager.setIdleMusic();
  gameData.musicManager.increaseLevel("base");
  if (
    gameController.currentBlazingMultiplier !==
      gameController.newBlazingMultiplier &&
    gameController.currentBlazingMultiplier <
      gameController.newBlazingMultiplier
  ) {
    let animationName = "x" + gameController.currentBlazingMultiplier + " Up";
    animationName = animationName.replace(".", "_");
    gameController.currentBlazingMultiplier += 0.5;

    gameController.currentBlazingMultiplier =
      gameController.currentBlazingMultiplier > 5
        ? 5
        : gameController.currentBlazingMultiplier;

    gameController.blazingMultiplierValue.setText(
      "X" + gameController.currentBlazingMultiplier
    );

    gameController.thermometer.play(animationName, false, 0, () => {
      gameController.spineMultiplierIncrease();
    });
  } else {
    let animationName = "x" + gameController.currentBlazingMultiplier;
    animationName = animationName.replace(".", "_");
    //If the spine track holds the same animation as the current one, we don't want to play it again.
    if (
      gameController.thermometer.children[0].state.tracks[0].animation.name !=
      animationName
    ) {
      gameController.thermometer.play(animationName, true, 0, undefined);
    }
    timerManager.addTimeout(500, () => {
      gameController.multiplierBoostTask.leave();
    });
  }
};

gameController.onVolcanoAddEvent = function (task) {
  console.log("🔵 Volcano Add");
  gameController.currentVolcanoLevel = task.data.newSize;
  if (!gameController.volcanoAnimLocked) {
    gameController.updateVolcanoLevel(task.data.newSize, true);
  }
};

gameController.onVolcanoResetEvent = function (task) {
  console.log("🔵 Volcano Reset");
  gameController.currentVolcanoLevel = 1;

  if (!gameController.volcanoAnimLocked) {
    gameController.updateVolcanoLevel(1, true);
  }
};

gameController.replayComplete = function () {
  // gameController.cyclingWins = true;
  // gameController.cycleWins();

  for (let i = 0; i < gameController.slotMachine._reelVisuals.length; i++) {
    gameController.slotMachine._reelVisuals[i].clearSuspendUpdates();
  }
};

gameController.onModal = function (event) {
  if (event.reason && event.reason !== "") {
    if (event.reason === "Platform Paused") {
      gameController.cancelAutoplay();
      autoplayManager.stopAutoplay();
      gameController.stoppingAutoplay = true;
      gameController.platformPaused = true;
    } else if (event.data && event.data === "Platform Popup Open") {
      gameController.platformPopupActive = true;
    }
  } else if (event.data) {
    if (
      event.data === "Platform Popup Close" &&
      !gameController.platformPaused
    ) {
      gameController.platformPopupActive = false;
    } else if (event.data === "Platform Resume") {
      gameController.platformPaused = false;
    }

    if (gameController.platformPopupActive || gameController.platformPaused) {
      gameController.cancelAutoplay();
      autoplayManager.stopAutoplay();
      gameController.stoppingAutoplay = true;
      messageBus.post("game:modal", {
        reason: "Keep locked",
        data: "Keep locked",
      });
    }
  }
};
gameController.onGameSkipped = function (stakeInfo) {
  // we make the meter show the correct stake on a restore, but nothing seems to set the stake controller up correctly if you press skip
  // so we have a new message and we do that here
  // ideally this should be in the libs somewhere!!
  const stakeController = resourceManager.getController("stakeController");

  // now we can have bonus buys on different stakes compared to normal
  // os 1st lets make sure the stake is valid for BASIC
  const stakeIndex = stakeController.Stakes.indexOf(stakeInfo.baseStake);
  if (stakeIndex === -1) {
    // the bonus buy stake isnt in the BASIC stake
    // so we need to use the default
    // this is assuming default stake has been set correctly :( as everything appears to be in closures!!
    stakeInfo.baseStake = stakeController.BaseStake;
  }

  stakeController.requestChangeStake(stakeInfo.baseStake);

  // as we skipped we should also hide the new messages
  // so the total win is shown
  // if (stakeInfo.win && stakeInfo.win > 0) {
  //   gameData.winningsMeter.visible = true;
  //   gameData.winningsMeter.set(stakeInfo.win);
  // }
};

Reflex.addToUpdate(gameController.update);
messageBus.subscribe("common:GameSkipped", gameController.onGameSkipped);

messageBus.subscribe("spinner:SpinEvent", gameController.doSpin);
messageBus.subscribe("8bofbb:JackpotBoost", gameController.doJackpotBoost);
messageBus.subscribe(
  "8bofbb:BlazingMultiplier",
  gameController.doMultiplierBoost
);
messageBus.subscribe("autoplay:started", gameController.autoplayStarted);
messageBus.subscribe("autoplay:ended", gameController.autoplayEnded);
messageBus.subscribe("stake:stakeChanged", gameController.onStakeChanged);
messageBus.subscribe("common:RecoverGame", gameController.recoverGame);
messageBus.subscribe("common:GameCompleteEvent", gameController.onGameComplete);
messageBus.subscribe("spinner:WinningLinesEvent", gameController.initPayWins);
messageBus.subscribe("game:modal", gameController.onModal);
messageBus.subscribe(
  "spinner:FreeSpinsStartEvent",
  gameController.onFreespinsStart
);
messageBus.subscribe(
  "spinner:FreeSpinsEndEventDead",
  gameController.onFreespinsEnd
);
messageBus.subscribe("common:AbortGame", gameController.onAbortGame);
messageBus.subscribe(
  "8bofBB:FireballLinkStartEvent",
  gameController.onfireballLinkStartEvent
);
messageBus.subscribe(
  "8bof:FireballLinkEndEventDead",
  gameController.onfireballLinkEndEvent
);
messageBus.subscribe(
  "8bofBB:FireballsLandedEvent",
  gameController.onFireballsLandedEvent
);
messageBus.subscribe(
  "8bof:FireballLinkEndEvent",
  gameController.onFireballLinkEndEvent
);
messageBus.subscribe(
  "8bof:EndOfBaseGameSpinEvent",
  gameController.onEndOfBaseGameSpinEvent
);
messageBus.subscribe("8bofbb:VolcanoAdd", gameController.onVolcanoAddEvent);
messageBus.subscribe("8bofbb:VolcanoReset", gameController.onVolcanoResetEvent);
messageBus.subscribe("8bof:initialRetrigger", gameController.onRetriggering);
messageBus.subscribe(
  "8bof:PotBonusStartEventDead",
  gameController.onPotBonusEndEvent
);
messageBus.subscribe(
  "8bofBB:PersistenceUpdate-UpdateToInitial",
  gameController.updateToInitialPersistenceState
);
messageBus.subscribe(
  "8bofBB:OverrideStartingPersistenceValues",
  gameController.overrideStartingPersistenceValues
);
messageBus.subscribe(
  "8bofBB:PersistenceUpdate-UpdateToAfterSpin",
  gameController.updateToEndOfSpinPersistenceState
);
messageBus.subscribe(
  "8bofBB:PersistenceUpdate-UpdateToStarting",
  gameController.SetIntialPersistenceValues
);
messageBus.subscribe("platform:ReplayComplete", gameController.replayComplete);
Reflex.registerEventHandler("layoutChange", gameController.onOrientationChange);
